import { useContext, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { EnterpriseContext } from "./EnterpriseContext";
import MonthlyCompanyStatsInnerComponent from "./MonthlyCompanyStatsInnerComponent";
import BoxDynamicAd from "../../ads/BoxDynamicAd";
import truckyService from "../../common/services/trucky-service";
import VTCMenu from "../../web/components/VTCMenu";
import Breadcrumbs from "../../web/components/Breadcrumbs";
import classNames from "classnames";
import AllTimeCompanyStats from "./AllTimeCompanyStats";
import CompanyMemberStats from "./CompanyMemberStats";

const MonthlyCompanyStats = ({ container }) => {
  const { globalContext } = useContext(EnterpriseContext);

  const company = globalContext.company;

  const [currentTab, setCurrentTab] = useState("overall");

  useEffect(() => {
    truckyService.setDocumentTitle("Company Stats");
  }, []);

  const [period, setPeriod] = useState("monthly");

  return (
    <>
      <Row noGutters className="" id="enterpriseContainer">
        <VTCMenu active="/stats" container={container}></VTCMenu>
        <Col>
          <Row noGutters>
            <Col>
              <Card>
                <CardBody>
                  <Breadcrumbs
                    breadcrumbs={[
                      {
                        to: "/vtchub",
                        title: container.localeManager.strings.vtcHub,
                      },
                      {
                        title: container.localeManager.strings.statistics,
                      },
                    ]}
                  ></Breadcrumbs>
                  <h5>{container.localeManager.strings.statistics}</h5>

                  <Nav
                    className="nav-custom nav-line-tabs nav-line-tabs-2x fs-6 fw-bold mb-3"
                    tabs
                  >
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: currentTab === "overall",
                        })}
                        onClick={() => {
                          setCurrentTab("overall");
                        }}
                      >
                        {container.localeManager.strings.alltime}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: currentTab === "period",
                        })}
                        onClick={() => {
                          setCurrentTab("period");
                        }}
                      >
                        {container.localeManager.strings.periodStats}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classNames({
                          active: currentTab === "members",
                        })}
                        onClick={() => {
                          setCurrentTab("members");
                        }}
                      >
                        {container.localeManager.strings.members}
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={currentTab}>
                    <TabPane tabId="overall">
                      {currentTab === "overall" && (
                        <AllTimeCompanyStats container={container} />
                      )}
                    </TabPane>
                    <TabPane tabId="period">
                      {currentTab === "period" && (
                        <MonthlyCompanyStatsInnerComponent
                          period={period}
                          company={company}
                          container={container}
                          enableNavigation={true}
                          detailedMembersStats={true}
                          detailedJobsStats={true}
                          showAggregatedStats={true}
                          showAggregatedJobsChart={true}
                        ></MonthlyCompanyStatsInnerComponent>
                      )}
                    </TabPane>
                    <TabPane tabId="members">
                      {currentTab === "members" && (
                        <CompanyMemberStats
                          company={company}
                          container={container}
                        ></CompanyMemberStats>
                      )}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
            {!container.dataService.data.enablePremiumFeature() && (
              <aside className="ad-column-placeholder">
                {!window.overwolf && (
                  <BoxDynamicAd container={container} className="my-3" />
                )}
              </aside>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default MonthlyCompanyStats;
